import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { fetchEmails } from '../actions';
import { fetchUser } from '../actions';
import EmailProps from '../proptypes/email';
import UserProps from '../proptypes/user';
import Profile from '../components/overview/Profile';

export class OverviewProfile extends Component {
  static propTypes = {
    actionFetchEmails: PropTypes.func.isRequired,
    actionFetchUser: PropTypes.func.isRequired,
    emails: PropTypes.arrayOf(EmailProps).isRequired,
    isFetchingEmails: PropTypes.bool.isRequired,
    user: UserProps.isRequired,
  };

  componentDidMount() {
    const {
      actionFetchEmails,
      actionFetchUser,
      emails,
      isFetchingEmails,
      user,
    } = this.props;

    if (!user.uuid && !user.isFetching) {
      actionFetchUser();
    }
    if (!emails.length && !isFetchingEmails) {
      actionFetchEmails();
    }
  }

  render() {
    const { emails, user } = this.props;
    const email = emails.find((email) => email.isPrimary);

    return <Profile email={email} user={user} />;
  }
}

export const mapStateToProps = (state) => ({
  emails: state.emails.emails,
  isFetchingEmails: state.emails.isFetching,
  user: state.user,
});

const mapDispatchToProps = {
  actionFetchEmails: fetchEmails,
  actionFetchUser: fetchUser,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OverviewProfile),
);
